import { useContext } from 'react';
import ReportPrintContext from '../../../../../StateManagment/ReportPrintContext';

/**
 * The display mode a carrousel widget (Onderzoek, Effect, Activiteit) should
 * render in. On the printvel every item must reach paper, so the carrousel is
 * stacked there whatever the widget is set to.
 *
 * @param {'navigator'|'stacked'} displayMode - The widget's own setting
 * @returns {'navigator'|'stacked'}
 */
const usePrintDisplayMode = (displayMode) => {
    const printing = useContext(ReportPrintContext);
    return printing ? 'stacked' : displayMode;
};

export default usePrintDisplayMode;
